import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';
import type { ColumnKey, Store } from '../../../store/list/types';

/*
 * It updated the columns model with the config coming from LocalStorage.
 * It makes sure that the displayed columns match with the latest user's preferences.
 */
export const setColumnsVisibility = (store: Store): void => {
  const { columns, setColumns } = store.getState();
  const columnsToConfig = LocalStorage.get('playbacksColumnsVisibilityState') as
    | Partial<Record<ColumnKey, boolean>>
    | undefined;
  if (!columnsToConfig) {
    return;
  }

  const columnsToConfigKeys = Object.keys(columnsToConfig) as ColumnKey[];
  const areAllStoredColumnsAccessible = columnsToConfigKeys.every(
    (columnKey) => !!columns[columnKey],
  );

  if (!areAllStoredColumnsAccessible) {
    // Fail-safe in case column stored in the local storage is not accessible
    LocalStorage.remove('playbacksColumnsVisibilityState');

    return;
  }

  columnsToConfigKeys.forEach((columnKey) => {
    columns[columnKey].show = columnsToConfig[columnKey] || false;
  });

  setColumns(columns);
};
